import { jwtDecode } from 'jwt-decode'

const decodeJwt = (jwt: string) => {
  try {
    return jwtDecode(jwt)
  } catch {
    return {}
  }
}

const getApplicationIdFromJwt = (jwt: string) => {
  const decoded = decodeJwt(jwt)
  return decoded.sub ?? ''
}

const getExpiryFromJwt = (jwt: string) => {
  const decoded = decodeJwt(jwt)
  return decoded.exp
}

export { decodeJwt, getApplicationIdFromJwt, getExpiryFromJwt }
